import { createContext, useContext } from 'react';
import type { GeoChartMeta } from './types';

export const metaContext = createContext<GeoChartMeta | null>(null);
export const useMetaContext = () => {
    const meta = useContext(metaContext);

    if (!meta) {
        throw new Error('GeoChartBody must be used within a GeoChart provider');
    }

    return meta;
};

export const HEADER_UNIT = 8;
export const HEADER_HEIGHT = 25 * HEADER_UNIT;

export const DEFAULT_COLUMN_WIDTH = 32;
export const DEPTH_COLUMN_WIDTH = 48;

export const DEPTH_STEP = 5;
export const DEPTH_OFFSET = 100;
export const DEFAULT_MIN_DEPTH = 100;
export const DEFAULT_MAX_DEPTH = 100;

export const DISTANCE_STEP = 1;
export const DEFAULT_MIN_X = 0;
export const DEFAULT_MAX_X = 100;
export const DEFAULT_SCALE = 0.1;

export const WELL_WIDTH = 26;
export const WELL_COLUMN_WIDTH = 0;
export const WELL_HEIGHT = 32;
export const COORD_WIDTH = 60;

export const PERFORATION_WIDTH = 72;
export const TESTING_WIDTH = 96;

export const SEAM_WIDTH = 4;

export const STRATUM_BG = '#b3b3b3';
export const SEAM_BG = '#a3a3a3';
